/* eslint-disable */

import React from 'react';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
import { Box, Button, Typography, Container } from '@mui/material';

// components
import { MotionContainer, varBounceIn } from '../components/animate';
import Page from '../components/Page';
import comingSoon from '../icons/coming_soon.jpg';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10),
  width: '100% !important'
}));

// ----------------------------------------------------------------------

export default function ComingSoon() {
  return (
    <RootStyle title="Coming Soon ">
      <Container>
        <MotionContainer initial="initial" open>
          <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
            <motion.div variants={varBounceIn}>
              <Typography variant="h3" paragraph>
                Coming Soon !
              </Typography>
            </motion.div>
            <Typography sx={{ color: 'text.secondary' }}>
              This feature is coming soon,keep checking this space.
            </Typography>

            <motion.div variants={varBounceIn}>
              <Box
                component="img"
                src={comingSoon}
                sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 5 } }}
              />
            </motion.div>

            <Button to="/" size="large" variant="contained" component={RouterLink}>
              Go to Home
            </Button>
          </Box>
        </MotionContainer>
      </Container>
    </RootStyle>
  );
}
